import {
  BankOutlined,
  CarOutlined,
  EditOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  MailOutlined,
  PhoneOutlined,
  PlusOutlined,
  ToolOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import s from "./MySidebar.module.scss";
import { useTranslation } from "react-i18next";

const MySidebar = () => {
  const user = useSelector((state) => state.cars.userDetails);
  const email = useSelector((state) => state.cars.email);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={s.personal_info}>
      <div className={s.header}>
        <div className={s.h4}>{t("personalAccount")}</div>
        <div className={s.imgWrapper}>
          <img
            src={user?.photo ? user?.photo : "/images/Profile-PNG-File.webp"}
            alt=''
            className={s.img}
          />
        </div>
      </div>
      <div className={s.contentWrapper}>
        <div className={s.content}>
          {(user?.first_name || user?.last_name) && (
            <div className={s.user_item}>
              <div className={s.user_item_label}>
                <UserOutlined className={s.icon} />
                {t("name")}:
              </div>
              <div className={s.user_item_value}>
                {user?.first_name} {user?.last_name}
              </div>
            </div>
          )}
          {user?.company_name && (
            <div className={s.user_item}>
              <div className={s.user_item_label}>
                <BankOutlined className={s.icon} />
                {t("company")}:
              </div>
              <div className={s.user_item_value}>{user?.company_name}</div>
            </div>
          )}
          <div className={s.user_item}>
            <div className={s.user_item_label}>
              <MailOutlined className={s.icon2} style={{ marginLeft: "1px" }} />
              {t("email")}:
            </div>
            <div className={s.user_item_value}>
              {user?.email ? user?.email : email}
            </div>
          </div>
          {user?.phone_number && (
            <div className={s.user_item}>
              <div className={s.user_item_label}>
                <PhoneOutlined className={s.icon} />
                {t("phone")}:
              </div>
              <div className={s.user_item_value}>{user?.phone_number}</div>
            </div>
          )}
          {user?.address && (
            <div className={s.user_item}>
              <div className={s.user_item_label}>
                <EnvironmentOutlined className={s.icon} />
                {t("address")}:
              </div>
              <div className={s.user_item_value}>{user?.address}</div>
            </div>
          )}
          {(user?.country || user?.city) && (
            <div className={s.user_item}>
              <div className={s.user_item_label}>
                <GlobalOutlined className={s.icon2} />
                {t("country")}:
              </div>
              <div className={s.user_item_value}>
                {user?.country} {user?.city}
              </div>
            </div>
          )}
        </div>
        <div className={s.panel_btns}>
          <Link to='/updateUser' className={s.panel_btn}>
            <EditOutlined />
            &nbsp; {t("updateProfile")}
          </Link>
          <Link to='/myAccount' className={s.panel_btn}>
            <CarOutlined />
            &nbsp; {t("myCars")}
          </Link>

          <Link to='/mySpares' className={s.panel_btn}>
            <ToolOutlined />
            &nbsp; {t("mySpares")}
          </Link>
          <Link to='/addAnnoucement' className={s.panel_btn}>
            <PlusOutlined />
            &nbsp; {t("addApplication")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MySidebar;
